import { useState } from "react";
import { toast } from "sonner";
import { PasswordInput } from "@/components/common/PasswordInput";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";
import { api, formatApiError } from "@/lib/api";

const EmailForm = () => {
  const { user, setUser } = useAuth();
  const [v, setV] = useState({ email: user.email, password: "" });
  const submit = async (e) => {
    e.preventDefault();
    try {
      const { data } = await api.post("/me/email", v);
      setUser(data); setV({ email: data.email, password: "" });
      toast.success("Adresse e-mail modifiée");
    } catch (err) { toast.error(formatApiError(err)); }
  };
  return (
    <form onSubmit={submit} className="space-y-3" data-testid="account-email-form">
      <h3 className="text-sm font-bold">Adresse e-mail de connexion</h3>
      <div className="grid gap-3 sm:grid-cols-2">
        <div><Label htmlFor="acc-email">Nouvelle adresse</Label><Input id="acc-email" type="email" required value={v.email} onChange={(e) => setV({ ...v, email: e.target.value })} className="mt-1.5 h-11" data-testid="account-email-input" /></div>
        <div><Label htmlFor="acc-email-pw">Mot de passe actuel</Label><PasswordInput id="acc-email-pw" required autoComplete="current-password" value={v.password} onChange={(e) => setV({ ...v, password: e.target.value })} className="mt-1.5 h-11" data-testid="account-email-password" /></div>
      </div>
      <Button type="submit" className="rounded-full" disabled={v.email.trim().toLowerCase() === user.email} data-testid="account-email-submit">Changer l'adresse</Button>
    </form>
  );
};

const PasswordForm = () => {
  const [v, setV] = useState({ current_password: "", new_password: "", confirm: "" });
  const submit = async (e) => {
    e.preventDefault();
    if (v.new_password !== v.confirm) { toast.error("Les deux mots de passe ne correspondent pas"); return; }
    try {
      await api.post("/me/password", { current_password: v.current_password, new_password: v.new_password });
      setV({ current_password: "", new_password: "", confirm: "" });
      toast.success("Mot de passe modifié");
    } catch (err) { toast.error(formatApiError(err)); }
  };
  const f = (k) => ({ value: v[k], onChange: (e) => setV({ ...v, [k]: e.target.value }), className: "mt-1.5 h-11", required: true });
  return (
    <form onSubmit={submit} className="space-y-3 border-t border-border pt-4" data-testid="account-password-form">
      <h3 className="text-sm font-bold">Mot de passe</h3>
      <div className="grid gap-3 sm:grid-cols-3">
        <div><Label htmlFor="acc-pw-cur">Actuel</Label><PasswordInput id="acc-pw-cur" autoComplete="current-password" {...f("current_password")} data-testid="account-password-current" /></div>
        <div><Label htmlFor="acc-pw-new">Nouveau (8 caractères min.)</Label><PasswordInput id="acc-pw-new" autoComplete="new-password" minLength={8} {...f("new_password")} data-testid="account-password-new" /></div>
        <div><Label htmlFor="acc-pw-conf">Confirmation</Label><PasswordInput id="acc-pw-conf" autoComplete="new-password" minLength={8} {...f("confirm")} data-testid="account-password-confirm" /></div>
      </div>
      <Button type="submit" className="rounded-full" data-testid="account-password-submit">Changer le mot de passe</Button>
    </form>
  );
};

export const AccountCard = () => {
  const { user } = useAuth();
  return (
    <section className="card-surface space-y-4 p-5 sm:p-6" data-testid="settings-account-card">
      <h2 className="text-lg font-bold">Identifiants de connexion</h2>
      {user.is_demo || user.read_only
        ? <p className="text-sm text-muted-foreground" data-testid="account-demo-disabled">Les identifiants des comptes de démonstration ne peuvent pas être modifiés.</p>
        : <><EmailForm /><PasswordForm /></>}
    </section>
  );
};
